module.exports = __webpack_public_path__ + "img/B@2x.eed61fb.webp";